import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from "@material-ui/core";
import React from "react";
import SpinnerButton from "../../../app/components/buttons/SpinnerButton";
import ErrorText from "../../../app/components/ErrorText";
import ControlledInput from "../../../app/components/inputs/ControlledInput";
import ControlledWholeNumberInput from "../../../app/components/inputs/ControlledWholeNumberInput";
import { RequestStateDto } from "../../../app/dtos/RequestStateDto";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { selectModalId } from "../../modal/state/modalSelectors";
import { closeModal } from "../../modal/state/modalSlice";
import { SnapInSchoolsCycleDto } from "../dtos/SnapInSchoolsCycleDto";
import { SnapInSchoolsFidelityAdherenceChecklistFormDto } from "../dtos/SnapInSchoolsFidelityAdherenceChecklistDto";
import { useSnapInSchoolsFidelityAdherenceChecklistForm } from "../hooks/useSnapInSchoolsFidelityAdherenceChecklistForm";

export const snapInSchoolsFidelityAdherenceChecklistModalId =
  "snap-in-schools-fidelity-adherence-form-modal";

interface Props {
  requestState: RequestStateDto;
  snapCycle?: SnapInSchoolsCycleDto;
  onSubmit(dto: SnapInSchoolsFidelityAdherenceChecklistFormDto): Promise<any>;
}

const SnapInSchoolsFidelityAdherenceFormDialog: React.FC<Props> = ({
  requestState,
  snapCycle,
  onSubmit,
}) => {
  //#region State
  const modalId = useAppSelector(selectModalId);
  const dispatch = useAppDispatch();

  const { form, handlers } = useSnapInSchoolsFidelityAdherenceChecklistForm(
    onSubmit,
    snapCycle
  );
  const { handleSubmit } = handlers;
  const { isValid, control, clearForm } = form;
  const { error, isLoading } = requestState;
  //#endregion

  //#region
  const handleCloseModal = async () => {
    clearForm();
    dispatch(closeModal());
  };
  //#endregion

  return (
    <Dialog
      open={modalId === snapInSchoolsFidelityAdherenceChecklistModalId}
      maxWidth="sm"
      fullWidth
    >
      <form onSubmit={handleSubmit}>
        <DialogTitle>
          {snapCycle?.fidelityAdherenceChecklist ? "Edit" : "Create"} SNAP in
          Schools and Communities Fidelity Adherence Checklist
          <ErrorText error={error?.message} />
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item md={12} xs={12}>
              <ControlledInput
                control={control}
                name="completedOn"
                label="Completed On*"
                type="date"
                disabled={isLoading}
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item md={12} xs={12}>
              <ControlledWholeNumberInput
                control={control}
                name="score"
                label="Score*"
                disabled={isLoading}
                fullWidth
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <SpinnerButton
            content="Cancel"
            showSpinner={false}
            type="button"
            onClick={handleCloseModal}
          />
          <SpinnerButton
            showSpinner={isLoading}
            content="Save"
            color="primary"
            type="submit"
            disabled={!isValid || isLoading}
          />
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default SnapInSchoolsFidelityAdherenceFormDialog;
